import env from '@/config/env';
import RANKING_LOJAS from '@/graphql/queries/RankingLojas.gql';
import BUSCA_VARIAVEIS_RANKING_LOJAS from '@/graphql/queries/RankingLojasBuscaMesAno.gql';
import BUSCAR_ANOS_RANKING_LOJAS from '@/graphql/queries/RankingLojasBuscarAno.gql';
import { errorGQLHandler } from '../../../helpers/helpers';

const Types = {
  REQUEST: 'REQUEST',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  REQUEST_ANOS: 'REQUEST_ANOS',
  SUCCESS_ANOS: 'SUCCESS_ANOS',
  UPDATE: 'UPDATE',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
};

export default {
  namespaced: true,
  state: {
    loading: false,
    ano: null,
    anos: [],
    data: [],
  },
  getters: {
    ano: state => state.ano,
    anos: state => state.anos,
    data: state => state.data,
    loading: state => state.loading,
  },
  mutations: {
    [Types.UPDATE](state) {
      state.loading = true;
    },
    [Types.REQUEST_ANOS](state) {
      state.loading = true;
      state.anos = [];
    },
    [Types.SUCCESS_ANOS](state, payload) {
      state.anos = payload;
    },
    [Types.REQUEST](state) {
      state.loading = true;
      state.data = [];
      state.ano = null;
    },
    [Types.SUCCESS](state, { data, ano }) {
      state.loading = false;
      state.data = data;
      state.ano = ano;
    },
    [Types.FAILURE](state) {
      state.loading = false;
    },
  },
  actions: {
    async getRankingLojas({ commit }, { ano }) {
      try {
        commit(Types.REQUEST);

        const query = await env.apollo.query({
          query: RANKING_LOJAS,
          variables: { ano },
          fetchPolicy: 'no-cache',
        });
        const { response } = query.data;

        commit(Types.SUCCESS, { data: response, ano });
      } catch (e) {
        commit(Types.FAILURE);
        if (e && e.message) {
          console.log(e.message);
          return;
        }
        errorGQLHandler(e);
      }
    },
    async getRankingLojasAno({ commit, dispatch }) {
      try {
        commit(Types.REQUEST_ANOS);

        const {
          data: { data },
        } = await env.apollo.query({
          query: BUSCAR_ANOS_RANKING_LOJAS,
          variables: {},
          fetchPolicy: 'no-cache',
        });

        console.log(data);

        const [{ ano }] = data;

        if (!ano) {
          throw new Error('Não existem ranking de lojas cadastrados para este usuário');
        }

        await dispatch('getRankingLojas', { ano });

        commit(Types.SUCCESS_ANOS, data);
      } catch (e) {
        commit(Types.FAILURE);
        if (e && e.message) {
          console.log(e.message);
          return;
        }
        errorGQLHandler(e);
      }
    },

    async findRankingLojasAno({ commit, dispatch }, ano) {},
  },
};
